import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MobileAdoptionPage } from '@/pages/super-admin/mobile-adoption/MobileAdoptionPage';

const mobileAdoptionSearchSchema = z.object({
	tab: z.enum(['overview', 'users']).default('overview'),
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(20),
	search: z.string().optional(),
	status: z.enum(['mobile', 'web-only']).optional(),
	period: z.enum(['7d', '30d', '90d']).default('30d'),
	sortBy: z.enum(['name', 'createdAt', 'lastActiveAt']).default('lastActiveAt'),
	sortOrder: z.enum(['asc', 'desc']).default('desc'),
});

export const Route = createFileRoute('/_authenticated/super-admin/mobile-adoption')({
	component: MobileAdoptionPage,
	validateSearch: mobileAdoptionSearchSchema,
});
